import { TOKEN_KEY } from 'src/constants/app'
import axios from 'axios'

export class ApiError {
  public readonly message: string
  public readonly code: string
  public readonly data?: any
  public readonly status: string

  constructor(
    message: string,
    code = 'UNKNOWN_ERROR',
    data = undefined,
    status: string
  ) {
    this.message = message
    this.code = code
    this.data = data
    this.status = status
  }
}

// Criando instancia do axios
const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  timeout: 30000, // 30s
})

// Request Middleware
api.interceptors.request.use(
  request => {
    const persistedToken = localStorage.getItem(TOKEN_KEY)

    if (persistedToken) {
      request.headers.Authorization = `Bearer ${persistedToken}`
    }

    return request
  },
  err => Promise.reject(err)
)

// Response Middleware
api.interceptors.response.use(
  response => {
    const data = response?.data

    //console.log(data)
    if (data.status === 'error') {
      // TODO: fire notification
      const { status, code, data: errorData, message } = data
      return Promise.reject(new ApiError(message, code, errorData, status))
    } else return data
  },
  err => {
    const { status, code, data, message } = err.response.data
    return Promise.reject(new ApiError(message, code, data, status))
  }
)

export default api
